module.exports = __webpack_public_path__ + "img/az_bg_2023_01_19.1f975a16.png";